// extracted by mini-css-extract-plugin
export default {"table":"backup-table_table__Bi+1J"};